export function ProjectCardSkeleton() {
  return (
    <div className="group relative bg-gradient-to-br from-[#0f1729] via-[#162037] to-[#1c2744] rounded-2xl overflow-hidden border border-blue-900/30">
      <div className="relative h-[300px] bg-gray-800/50 animate-pulse" />
      <div className="p-8">
        <div className="h-8 w-3/4 bg-gray-700/50 rounded-lg animate-pulse mb-6" />
        <div className="space-y-3">
          <div className="h-4 w-full bg-gray-700/50 rounded-lg animate-pulse" />
          <div className="h-4 w-full bg-gray-700/50 rounded-lg animate-pulse" />
          <div className="h-4 w-5/6 bg-gray-700/50 rounded-lg animate-pulse" />
        </div>
      </div>
    </div>
  );
} 